import React from 'react';
import { CalendarClock, ShieldAlert, Star } from 'lucide-react';
import { formatUzun, kalanSure } from './formatlayicilar';

// Özet panelindeki tarih kartı (Olağan / Olağanüstü). Geçerli (önce dolan) olan yıldız + rozetle vurgulanır.
function TarihKarti({ etiket, ref67, tarih, gecerli, doldu }) {
  const dateCls = gecerli ? (doldu ? 'text-rose-700' : 'text-emerald-700') : 'text-slate-800';
  const cardCls = gecerli
    ? doldu
      ? 'border-rose-300 ring-1 ring-rose-200'
      : 'border-emerald-300 ring-1 ring-emerald-200'
    : 'border-slate-200';
  return (
    <div className={`rounded-lg border bg-white p-3.5 ${cardCls}`}>
      <div className="flex items-start justify-between gap-2">
        <p className="text-[11px] font-medium uppercase tracking-wide text-slate-400">
          {etiket} <span className="ml-0.5 normal-case text-slate-300">{ref67}</span>
        </p>
        {gecerli ? (
          <span
            title="Önce dolan/dolacak tarih — dava bu tarihte düşer"
            className={`inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold ${
              doldu ? 'bg-rose-100 text-rose-700' : 'bg-emerald-100 text-emerald-700'
            }`}
          >
            <Star className="h-3 w-3 fill-current" /> Geçerli
          </span>
        ) : null}
      </div>
      <p className={`mt-1.5 text-base font-bold ${dateCls}`}>{tarih}</p>
    </div>
  );
}

/**
 * Zamanaşımı özet paneli — Olağan / Olağanüstü / Kalan(Sonuç) kartları.
 * Geçerli (önce dolan) tarih yıldız + "Geçerli" rozetiyle vurgulanır; durum rengi panele yansır.
 */
export default function ZamanAsimiOzet({ sonuc }) {
  if (!sonuc) return null;
  const doldu = sonuc.zamanAsimiDoldu;
  const ks = kalanSure(sonuc);
  const gerekce = sonuc.capApplied
    ? 'Olağan tarih üst sınırı aştığından TCK 67/4 mutlak üst sınır tarihi esas alınmıştır.'
    : sonuc.hasKesme
    ? 'Kesilmelerle yeniden işleyen olağan süre esas alınmıştır.'
    : 'Kesilme bulunmadığından olağan zamanaşımı tarihi esas alınmıştır.';

  return (
    <div
      className={`rounded-xl border p-4 sm:p-5 ${
        doldu ? 'border-rose-200 bg-rose-50' : 'border-emerald-200 bg-emerald-50'
      }`}
    >
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        <TarihKarti
          etiket="Olağan Z.A."
          ref67="66/1"
          tarih={formatUzun(sonuc.olaganZamanAsimi)}
          gecerli={!sonuc.capApplied}
          doldu={doldu}
        />
        <TarihKarti
          etiket="Olağanüstü Z.A."
          ref67="67/4"
          tarih={formatUzun(sonuc.olaganustuZamanAsimi)}
          gecerli={sonuc.capApplied}
          doldu={doldu}
        />
        <div
          className={`flex flex-col rounded-lg border p-3.5 ${
            doldu ? 'border-rose-200 bg-rose-100/50' : 'border-emerald-200 bg-emerald-100/50'
          }`}
        >
          <div className="flex items-center gap-1.5">
            {doldu ? (
              <ShieldAlert className="h-3.5 w-3.5 shrink-0 text-rose-600" />
            ) : (
              <CalendarClock className="h-3.5 w-3.5 shrink-0 text-emerald-600" />
            )}
            <p className="text-[11px] font-medium uppercase tracking-wide text-slate-500">
              {doldu ? 'Sonuç' : 'Kalan süre'}
            </p>
          </div>
          <p className={`mt-1.5 text-base font-bold ${doldu ? 'text-rose-700' : 'text-emerald-700'}`}>
            {doldu ? 'Zamanaşımı doldu' : ks.sure}
          </p>
          {!doldu && ks.cokParcali ? (
            <p className="mt-0.5 text-[11px] tabular-nums text-slate-400">{ks.gun}</p>
          ) : null}
        </div>
      </div>
      <p className="mt-3 text-xs leading-snug text-slate-500">{gerekce}</p>
    </div>
  );
}
